module.exports = __webpack_public_path__ + "b97e91b150d46b4d7a4267789c3f1f61.png";